import * as React from "react";
import Modal from "react-modal";
import { IconClose } from "themes/icons";
import "./modal.less";
export interface IModalViewCartProps {
  isOpenModal: boolean;
  onCloseModal: () => void;
  okText?: string;
  cancelText?: string;
  onOk?: () => void;
  onCancel?: () => void;
  title?: string;
  width?: number | string;
  height?: number | string;
  isModal?: boolean;
  isCustomizeFooter?: boolean;
  className?: string;
  portalClassName?: string;
  children?:
  | JSX.Element
  | JSX.Element[]
  | React.ReactChild
  | React.ReactChild[]
  | React.ReactNode;
}
Modal.setAppElement("#root");
export function ModalComponent(props: IModalViewCartProps) {
  const {
    okText,
    cancelText,
    onOk,
    onCancel,
    isOpenModal,
    onCloseModal,
    children,
    isModal,
    isCustomizeFooter,
    width,
    height,
    portalClassName,
    title,
    className,
  } = props;
  return (
    <Modal
      portalClassName={portalClassName}
      closeTimeoutMS={500}
      isOpen={isOpenModal}
      onRequestClose={onCloseModal}
      className={`rounded-2xl shadow-2xl drop-shadow-2xl bg-white outline-none xl:w-3/5 mx-auto sm:w-full ${className}`}
      overlayClassName="Overlay"
      style={{
        content: {
          width: width,
          height: height,
        },
      }}
    >
      <div className={``}>
        <div className="modal-react-header border-b py-2 flex justify-between content-center items-center">
          {title && (
            <h2 className="font-semibold xl:text-md lg:text-md xs:text-sm w-full text-center">{title}</h2>
          )}
          <div className="icon">
            <button onClick={onCloseModal}>
              <IconClose width={15} />
            </button>
          </div>
        </div>
        <div className="modal-react-content ">{children}</div>
        {!isCustomizeFooter && (
          <div className="space-x-2 text-center pt-5 mx-auto py-2 bottom-0 border-t  border-gray-300 modal-react-footer">
            <button
              onClick={onOk}
              className="btn--default px-8 transition-primary  uppercase btn--secondary hover:btn--secondary"
            >
              {okText ?? "Save"}
            </button>
            <button
              onClick={onCancel}
              className="btn--default px-8 transition-primary uppercase btn--primary"
            >
              {cancelText ?? "Cancel"}
            </button>
          </div>
        )}
      </div>
    </Modal>
  );
}
